export default function LockCircleIcon({
  size = 52,
  className = "text-[#067647]",
  title = "قفل",
}: {
  size?: number;
  className?: string;
  title?: string;
}) {
  // Sanitized: filters/scripts removed. Stroke/fill use currentColor for easy theming.
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 52 52"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={title}
      role="img"
      className={className}
      preserveAspectRatio="xMidYMid meet"
    >
      {/* outer circle */}
      <path
        d="M2.5 25C2.5 12.0213 13.0213 1.5 26 1.5C38.9787 1.5 49.5 12.0213 49.5 25C49.5 37.9787 38.9787 48.5 26 48.5C13.0213 48.5 2.5 37.9787 2.5 25Z"
        fill="none"
        stroke="currentColor"
      />
      {/* keypad dots */}
      <path d="M22.5 28.5C22.5 27.9477 22.9477 27.5 23.5 27.5H23.509C24.0613 27.5 24.509 27.9477 24.509 28.5C24.509 29.0523 24.0613 29.5 23.509 29.5H23.5C22.9477 29.5 22.5 29.0523 22.5 28.5Z" fill="currentColor"/>
      <path d="M27.491 28.5C27.491 27.9477 27.9387 27.5 28.491 27.5H28.5C29.0523 27.5 29.5 27.9477 29.5 28.5C29.5 29.0523 29.0523 29.5 28.5 29.5H28.491C27.9387 29.5 27.491 29.0523 27.491 28.5Z" fill="currentColor"/>
      {/* lock body + shackle */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.75 21.4591V19.5C20.75 16.6005 23.1005 14.25 26 14.25C28.8995 14.25 31.25 16.6005 31.25 19.5V21.4591C32.9408 21.8628 34.239 23.2984 34.4755 25.0552C34.6236 26.1556 34.75 27.3118 34.75 28.5C34.75 29.6882 34.6236 30.8444 34.4755 31.9448C34.2039 33.9618 32.5328 35.5555 30.4748 35.6501C29.0464 35.7158 27.5958 35.75 26 35.75C24.4042 35.75 22.9536 35.7158 21.5252 35.6501C19.4672 35.5555 17.7961 33.9618 17.5245 31.9448C17.3764 30.8444 17.25 29.6882 17.25 28.5C17.25 27.3118 17.3764 26.1556 17.5245 25.0552C17.761 23.2984 19.0592 21.8628 20.75 21.4591ZM22.25 19.5C22.25 17.4289 23.9289 15.75 26 15.75C28.0711 15.75 29.75 17.4289 29.75 19.5V21.3194C28.5532 21.2737 27.3269 21.25 26 21.25C24.6732 21.25 23.4468 21.2737 22.25 21.3194V19.5ZM26 22.75C24.4264 22.75 22.9989 22.7837 21.5941 22.8483C20.2851 22.9085 19.1893 23.9319 19.0111 25.2553C18.8657 26.3351 18.75 27.4129 18.75 28.5C18.75 29.5871 18.8657 30.6649 19.0111 31.7447C19.1893 33.0681 20.2851 34.0915 21.5941 34.1517C22.9989 34.2163 24.4264 34.25 26 34.25C27.5736 34.25 29.0011 34.2163 30.4059 34.1517C31.7149 34.0915 32.8107 33.0681 32.9889 31.7447C33.1343 30.6649 33.25 29.5871 33.25 28.5C33.25 27.4129 33.1343 26.3351 32.9889 25.2553C32.8107 23.9319 31.7149 22.9085 30.4059 22.8483C29.0011 22.7837 27.5736 22.75 26 22.75Z"
        fill="currentColor"
      />
    </svg>
  );
}
